import React, { useEffect, useState, useRef } from 'react';
import { View, Text, StyleSheet, TextInput, Pressable } from '../lib/react-native-compat';
import { useAtom } from 'jotai';
import { laborValues, equipmentValues } from '../store/faceValues';
import { updateUserDataArray, loadUserData, loadHEETData, fNum, pNum, effectiveIsProjectCoordinator, effectiveIsBuyer } from '../db/company';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { selectedJobAtom, jobUserDataAtom, jobCostDetailAtom, selectedJobDataAtom, selectedVersionAtom, projectCompleteAtom, dataSourceVersionAtom, isLiveVersionAtom, selectedVersionLockedAtom, startDateActualAtom, userNameAtom, userIdAtom, jobHEETDataAtom, userEmailCheckAtom, userRoleAtom, previewRoleAtom } from '../store/company';
import { useApiTracker } from '../store/useApiStatus';
import moment from 'moment';
import { ManpowerPlanning } from './manpowerPlanning';
import { colors } from './burnToolPhasedStyles';
import AuditHistoryPanel from './auditHistoryPanel';

// Non-phased jobs plan a single crew, so Manpower Planning treats the whole
// job as one "ALL" activity in the phase-shaped props it shares with the
// phased burn tool.
const MP_ALL_LABOR_PHASES = [{ code: 'ALL', description: 'All Labor' }]

const BurnTool = (props) => {
    const trackApi = useApiTracker('burnToolLabor');
    const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom);
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [selectedJobData, setSelectedJobData] = useAtom(selectedJobDataAtom);
    const [versions, setVersions] = useAtom(dataSourceVersionAtom);
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [lockedVersion, setLockedVersion] = useAtom(selectedVersionLockedAtom)
    const [startDateActual, setStartDateActual] = useAtom(startDateActualAtom);
    const [userName] = useAtom(userNameAtom);
    const [userId] = useAtom(userIdAtom);
    const [versionInfo, setVersionInfo] = useState({});
    const sideMenuOpen = props.sideMenuOpen
    const width = window.innerWidth;
    const [labor, setLabor] = useAtom(laborValues);
    const [equipment, setEquipment] = useAtom(equipmentValues);
    const [historicalWeeks, setHistoricalWeeks] = useState([])
    const [estimatedWeeks, setEstimatedWeeks] = useState([])
    const [truckPay, setTruckPay] = useState([])
    const [rigRent, setRigRent] = useState([])
    const [equipmentBurn, setEquipmentBurn] = useState([])
    const [actualLaborCost, setActualLaborCost] = useState(0)
    const [actualLaborHours, setActualLaborHours] = useState(0)
    const [forecastLaborHours, setForecastLaborHours] = useState(0)
    const [forecastLaborCost, setForecastLaborCost] = useState(0)
    const [totalCOHours, setTotalCOHours] = useState(0)
    const [totalCOCost, setTotalCOCost] = useState(0)
    const [totalDayZero, setTotalDayZero] = useState(0)
    const [totalDayZeroHours, setTotalDayZeroHours] = useState(0)
    const [currentBudget, setCurrentBudget] = useState('-')
    const [currentBudgetHours, setCurrentBudgetHours] = useState('-')
    const [totalCost, setTotalCost] = useState(0)
    const [totalHours, setTotalHours] = useState(0)
    const [overUnder, setOverUnder] = useState(0)
    const [overUnderHours, setOverUnderHours] = useState(0)
    const [percentComplete, setPercentComplete] = useState(0)
    const [percentCompleteHours, setPercentCompleteHours] = useState(0)
    const [jobUserData, setJobUserData] = useAtom(jobUserDataAtom);
    const [jobCostDetail, setJobCostDetail] = useAtom(jobCostDetailAtom);
    const [completionDateForecast, setCompletionDateForecast] = useAtom(projectCompleteAtom);
    const [totalEstHours, setTotalEstHours] = useState(0)
    const [totalEstCost, setTotalEstCost] = useState(0)
    const [totalActualHours, setTotalActualHours] = useState(0)
    const [totalActualCost, setTotalActualCost] = useState(0)
    const [totalForecastedHours, setTotalForecastedHours] = useState(0)
    const [totalHourPerWeek, setTotalHourPerWeek] = useState(0)
    const [totalBurnPerHour, setTotalBurnPerHour] = useState(0)
    const [totalLaborEst, setTotalLaborEst] = useState(0)
    const [totalLaborHoursEst, setTotalLaborHoursEst] = useState(0)
    const [totalCummalitiveHours, setTotalCummalitiveHours] = useState(0)
    const [jobHEETData, setJobHEETData] = useAtom(jobHEETDataAtom);
    const [heetWeeklyData, setHeetWeeklyData] = useState({})
    const [userEmailCheck] = useAtom(userEmailCheckAtom);
    const [userRole] = useAtom(userRoleAtom);
    const [previewRole] = useAtom(previewRoleAtom);
    const canSeeWipTabs = true;
    // Project Coordinators only get the Manpower Planning subtab — the burn-tool
    // cost grid never renders for them (see pcAllowedTabs in db/company.js).
    // Derived (not initial state) so it holds even when the role loads late.
    const isPC = effectiveIsProjectCoordinator(previewRole, userRole, userEmailCheck) || effectiveIsBuyer(previewRole, userRole, userEmailCheck);
    const [mpSubTab, setMpSubTab] = useState('burn')
    const activeMpTab = isPC ? 'manpower' : mpSubTab;
    const [mpAllWeeks, setMpAllWeeks] = useState(false)
    const [projectWeeks, setProjectWeeks] = useState([])
    const [projectDates, setProjectDates] = useState({})
    const [projectWeeksData, setProjectWeeksData] = useState({})
    const [mpUserData, setMpUserData] = useState({})
    const localChanges = useRef([])
    const focusedId = useRef(null)

    const s = StyleSheet.create({
        topContainer: {
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: 5
        },
        container: {
            flexDirection: 'row',
            paddingBottom: 0,
            borderBottomWidth: 1,
            borderColor: '#F9F8FB'
        },
        smallContainer: {

        },
        span2: {
            width: 150,
            alignItems: 'center',
            fontSize: 14,
            padding: 1

        },
        span: {
            width: 75,
            alignItems: 'center',
            fontSize: 14,
            padding: 1,
            textAlign: 'right'


        },
        span3: {
            width: 225,
            alignItems: 'center',
            fontSize: 12,
            padding: 3
        },
        span2T: {
            width: 125,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            border: '1px solid #e0e0e0',
            borderRight: '2px solid #e0e0e0'
        },
        spanHT: {
            width: 40,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right'
        },
        spanT: {
            width: 75,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right',
            border: '1px solid #e0e0e0',
            borderRight: '2px solid #e0e0e0'
        },
        spanTH: {
            width: 75,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right',
            backgroundColor: 'lightyellow'
        },
        span3T: {
            width: 225,
            alignItems: 'center',
            fontSize: 12,
            padding: 3
        },
        spanH: {
            width: 75,
            alignItems: 'center',
            fontSize: 12,
            padding: 4,
            textAlign: 'right',
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#f1f5f9',
            color: '#334155',
            fontWeight: '600',
        },
        spanWeek: {
            width: 100,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right',
            border: '1px solid #e0e0e0',
            borderRight: '2px solid #e0e0e0',
        },
        spanWeekH: {
            width: 100,
            alignItems: 'center',
            fontSize: 12,
            padding: 4,
            textAlign: 'right',
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#f1f5f9',
            color: '#334155',
            fontWeight: '600',
        },
        spanWeekTotals: {
            width: 100,
            alignItems: 'center',
            fontSize: 12,
            padding: 2,
            textAlign: 'right',
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#fef3c7',
            fontWeight: '700',
            color: '#1e293b',
        },
        span2H: {
            width: 125,
            alignItems: 'center',
            fontSize: 12,
            padding: 4,
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#f1f5f9',
            color: '#334155',
            fontWeight: '600',
        },
        spanHH: {
            width: 40,
            alignItems: 'center',
            fontSize: 12,
            padding: 4,
            textAlign: 'right',
            backgroundColor: '#f1f5f9',
            color: '#334155',
            fontWeight: '600',
        },
        span3H: {
            width: 225,
            alignItems: 'center',
            fontSize: 12,
            padding: 4,
            backgroundColor: '#f1f5f9',
            color: '#334155',
            fontWeight: '600',
        },
        spanTotals: {
            width: 75,
            alignItems: 'center',
            fontSize: 12,
            padding: 2,
            textAlign: 'right',
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#fef3c7',
            fontWeight: '700',
            color: '#1e293b',
        },
        span2Totals: {
            width: 125,
            alignItems: 'center',
            fontSize: 12,
            padding: 2,
            border: '1px solid #cbd5e1',
            borderRight: '2px solid #cbd5e1',
            backgroundColor: '#fef3c7',
            fontWeight: '700',
            color: '#1e293b',
        },
        spanHTotals: {
            width: 40,
            alignItems: 'center',
            fontSize: 12,
            padding: 2,
            textAlign: 'right',
            backgroundColor: '#fef3c7',
            fontWeight: '700',
            color: '#1e293b',
        },
        span3Totals: {
            width: 225,
            alignItems: 'center',
            fontSize: 12,
            padding: 2,
            backgroundColor: '#fef3c7',
            fontWeight: '700',
            color: '#1e293b',
        },
        sectionTitle: {
            fontSize: 18,
            paddingVertical: 10,
            paddingHorizontal: 4,
            fontWeight: '700',
            color: '#1e293b',
            letterSpacing: 0.3,
        },
        card: {
            width: 300,
            //boxShadow: "10px 10px 17px -12px rgba(0,0,0,0.75)",
            borderRadius: 5,
            padding: 8,
            borderWidth: .5,
            borderColor: 'lightgrey',
        },
        tInput: {
            borderWidth: .5,
            borderColor: 'grey',
            borderLeftWidth: 3,
            width: 75,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'right',
        },
        tInputL: {
            borderWidth: .5,
            borderColor: 'grey',
            borderLeftWidth: 3,
            width: 225,
            alignItems: 'center',
            fontSize: 12,
            padding: 1,
            textAlign: 'left',
        }
    })

    useEffect(() => {
        versions && versions.length > 0 && setVersionInfo(versions.find(v => v.Version_GUID === selectedVersion))
    }, [versions]);

    useEffect(() => {
        if (selectedJob && selectedVersion) {
            trackApi('loadUserData', 'load', () => loadUserData({ id: selectedJob, forecastGuid: selectedVersion, live: isLiveVersion })).then((data) => {
                setJobUserData(data?.data);
            }).catch(() => {})
        }
    }, [selectedJob, selectedVersion])

    useEffect(() => {
        // Load HEET data when job changes
        if (selectedJob) {
            trackApi('loadHEETData', 'load', () => loadHEETData({ id: selectedJob })).then((data) => {
                setJobHEETData(data?.data);
            }).catch(() => {})
        }
    }, [selectedJob])

    useEffect(() => {
        console.log('recacl')
        calculateTotals()
    }, [jobCostDetail, jobUserData, completionDateForecast, startDateActual, jobHEETData])

    const calculateTotals = () => {
        if (!jobUserData || !jobCostDetail) {
            return
        }
        const uData = {}
        const tData = {}
        const rData = {}
        const bData = {}
        const coData = {}
        let dayZeroTotal = 0
        let dayZeroHoursTotal = 0
        let totalCOCost = 0
        let totalCOHours = 0

        jobUserData.forEach((d) => {
            const row = d?.Forecast_Row_ID.split('*')[0]
            if (d?.Forecast_Tab === 'Burn Tool Labor') {
                if (d?.Cost_Type >= '51100' && d?.Cost_Type <= '51799') {
                    uData[row] = {
                        id: row,
                        ...d
                    }
                }
            }

            if (d?.Forecast_Tab === 'Change Order') {
                coData[d?.Forecast_User_Data_GUID || d?.Forecast_Row_ID] = { ...d, [d.Cost_Type]: d.Value_Amount, id: d.Row_Label }
            }

            if (d?.Forecast_Tab === 'Day Zero Budget') {
                bData[row] = d
            }
        })

        console.log('uData', uData)

        Object.values(coData).forEach((row) => {
            if (row['Hours'] && row['Status'] === 'Approved' && (row['Forecast_Field_Name'] === 'totalLaborHours' ||
                (String(row['Cost_Type'] || '').trim() === '51100' && row['Forecast_Field_Name'] !== 'totalEquipmentHours'))) {
                totalCOHours = totalCOHours + (pNum(row['Hours']) ? pNum(row['Hours']) : 0)
            }

            if (row['51100'] && row['Status'] === 'Approved') {
                totalCOCost = totalCOCost + (pNum(row['51100']) ? pNum(row['51100']) : 0)
            }

            if (row['51200'] && row['Status'] === 'Approved') {
                totalCOCost = totalCOCost + (pNum(row['51200']) ? pNum(row['51200']) : 0)
            }

            if (row['51300'] && row['Status'] === 'Approved') {
                totalCOCost = totalCOCost + (pNum(row['51300']) ? pNum(row['51300']) : 0)
            }

            if (row['51400'] && row['Status'] === 'Approved') {
                totalCOCost = totalCOCost + (pNum(row['51400']) ? pNum(row['51400']) : 0)
            }

            if (row['51500'] && row['Status'] === 'Approved') {
                totalCOCost = totalCOCost + (pNum(row['51500']) ? pNum(row['51500']) : 0)
            }

            if (row['51600'] && row['Status'] === 'Approved') {
                totalCOCost = totalCOCost + (pNum(row['51600']) ? pNum(row['51600']) : 0)
            }

            if (row['51700'] && row['Status'] === 'Approved') {
                totalCOCost = totalCOCost + (pNum(row['51700']) ? pNum(row['51700']) : 0)
            }
        })

        console.log('bData', bData)
        Object.values(bData).forEach((row) => {
            if (row['Value_Amount'] && (row['Cost_Type'] == '51100') || (row['Cost_Type'] == '51200') || (row['Cost_Type'] == '51300') || (row['Cost_Type'] == '51400') || (row['Cost_Type'] == '51500') || (row['Cost_Type'] == '51600') || (row['Cost_Type'] == '51700')) {
                dayZeroTotal = dayZeroTotal + (pNum(row['Value_Amount']) ? pNum(row['Value_Amount']) : 0)
            }

            if (row['Hours'] && (row['Cost_Type'] == '51100') || (row['Cost_Type'] == '51200') || (row['Cost_Type'] == '51300') || (row['Cost_Type'] == '51400') || (row['Cost_Type'] == '51500') || (row['Cost_Type'] == '51600') || (row['Cost_Type'] == '51700')) {
                dayZeroHoursTotal = dayZeroHoursTotal + (pNum(row['Hours']) ? pNum(row['Hours']) : 0)
            }
        })

        setTotalCOCost(fNum(totalCOCost, 1))
        setTotalCOHours(fNum(totalCOHours, 1))
        setTotalDayZero(fNum(dayZeroTotal, 1))
        setTotalDayZeroHours(fNum(dayZeroHoursTotal, 1))
        setCurrentBudget(fNum(totalCOCost + dayZeroTotal, 1))
        setCurrentBudgetHours(fNum(totalCOHours + dayZeroHoursTotal, 1))

        const laborRows = []
        const employeeCount = {}
        let totalHours = 0
        let totalCost = 0

        jobCostDetail?.forEach((row) => {
            if (row.Cost_Type_Code >= "51000" && row.Cost_Type_Code <= "51799") {
                laborRows.push(row)
                totalHours = totalHours + row.Total_Hours
                totalCost = totalCost + row.Job_Cost
                employeeCount[row.Staff_ID] = 1
            }
        })
        setActualLaborCost(fNum(totalCost, 1))
        setActualLaborHours(fNum(totalHours, 1))
        //go through and group total amount by week from project starts to ends 
        let dateSections = {}
        let uniqueWeeks = {}
        // Check for cost history data earlier than the planned start date
        let plannedStart = moment(selectedJobData?.Planned_Start_Date)

        jobCostDetail?.forEach((row) => {
            const rowDate = moment(row.Consolidated_Date);
            if (row.Cost_Type_Code >= "51000" && row.Cost_Type_Code <= "51799" && row.Job_Cost > 0) {
                if (rowDate.isBefore(plannedStart)) {
                    console.log('setting newer start date')
                    plannedStart = rowDate
                }
            }
        });
        const plannedFinish = moment(completionDateForecast ? completionDateForecast : selectedJobData?.Planned_Complete_Date)
        
        let currentDay = plannedStart
        let currentWeek = plannedStart.startOf('isoWeek')
        const days = plannedFinish.diff(plannedStart, 'days')
        for (let i = 0; i < days; i++) {
            const day = currentDay.clone()
            const week = currentDay.clone()
            day.add(i, 'days')
            week.add(i, 'days')
            currentWeek = week.startOf('isoWeek')
            const currentDayFormatted = day.format('YYYY-MM-DD')
            uniqueWeeks[currentWeek.format('YYYY-MM-DD')] = 1
            dateSections[currentDayFormatted] = [currentWeek.format('YYYY-MM-DD')]
        }

        //go through each labor row and add to the dateSections
        const weeksHours = {}
        const weeksAmount = {}
        const weeksData = {}
        let totalLaborHours = 0
        laborRows.forEach((row) => {
            totalLaborHours = totalLaborHours + pNum(row.Total_Hours)
            const rowDate = moment(row.Consolidated_Date).add(12, 'hours').startOf('isoWeek')
            const rowDateFormatted = rowDate.format('YYYY-MM-DD')
            if (weeksHours[rowDateFormatted]) {
                weeksHours[rowDateFormatted] = weeksHours[rowDateFormatted] + pNum(row.Total_Hours)
            } else {
                weeksHours[rowDateFormatted] = pNum(row.Total_Hours)
            }

            if (weeksAmount[rowDateFormatted]) {
                weeksAmount[rowDateFormatted] = weeksAmount[rowDateFormatted] + row.Job_Cost
            } else {
                weeksAmount[rowDateFormatted] = row.Job_Cost
            }

            if (weeksData[rowDateFormatted] && !weeksData[rowDateFormatted][row.Staff_ID]) {
                weeksData[rowDateFormatted][row.Staff_ID] = 1
                weeksData[rowDateFormatted]['count'] = weeksData[rowDateFormatted]['count'] + 1
            } else if (!weeksData[rowDateFormatted]) {
                weeksData[rowDateFormatted] = {
                    [row.Staff_ID]: 1,
                    count: 1
                }
            }
        })
        setActualLaborHours(fNum(totalLaborHours, 1))

        // Process HEET data by week
        const heetWeeks = {}
        if (jobHEETData && Array.isArray(jobHEETData)) {
            jobHEETData.forEach((row) => {
                if (row.GL_Date && row.GL_Amount) {
                    const rowDate = moment(row.GL_Date).startOf('isoWeek')
                    const rowDateFormatted = rowDate.format('YYYY-MM-DD')
                    if (heetWeeks[rowDateFormatted]) {
                        heetWeeks[rowDateFormatted] = heetWeeks[rowDateFormatted] + pNum(row.GL_Amount)
                    } else {
                        heetWeeks[rowDateFormatted] = pNum(row.GL_Amount)
                    }
                }
            })
        }
        console.log('heetWeeks', heetWeeks)
        setHeetWeeklyData(heetWeeks)

        const historicalWeeks = []
        const estimatedWeeks = []
        let cummalitiveHours = 0
        let cummalitiveHoursAct = 0
        let cummalativeHoursEst = 0
        let cummalitiveCostEst = 0
        let cummalitiveLaborEst = 0
        let totalActualWeekHours = 0
        let totalActualWeekCost = 0
        let totalEstWeekHours = 0
        let totalEstWeekCost = 0
        let totalHourPerWeek = 0
        let totalForecastedHours = 0

        Object.keys(uniqueWeeks).forEach((week, index) => {
            if (plannedFinish.isAfter(moment(week)) && moment(week).isAfter(moment(versionInfo.Version_Start_DateTime).add(-7, 'days'))) {
                cummalitiveHours = cummalitiveHours + (uData[week] ? (uData[week].Number_Hours ? pNum(uData[week].Number_Hours) : 0) * (uData[week].Number_Units ? pNum(uData[week].Number_Units) : 0) : 0)
                cummalativeHoursEst = cummalativeHoursEst + (uData[week] ? (uData[week].Number_Hours ? pNum(uData[week].Number_Hours) : 0) * (uData[week].Number_Units ? pNum(uData[week].Number_Units) : 0) : 0)
                cummalitiveLaborEst = cummalitiveLaborEst + (uData[week] ? (uData[week].Number_Hours ? pNum(uData[week].Number_Hours) : 0) * (uData[week].Number_Units ? pNum(uData[week].Number_Units) : 0) * (uData[week].Rate ? pNum(uData[week].Rate) : 0) : 0)
                cummalitiveCostEst = cummalitiveCostEst + (uData[week] ? (uData[week].Number_Hours ? pNum(uData[week].Number_Hours) : 0) * (uData[week].Number_Units ? pNum(uData[week].Number_Units) : 0) * (uData[week].Rate ? pNum(uData[week].Rate) : 0) : 0)
                totalHourPerWeek = totalHourPerWeek + (uData[week] ? pNum(uData[week]?.Number_Hours) : 0)
                totalEstWeekCost = totalEstWeekCost + (uData[week] ? (uData[week].Number_Hours ? pNum(uData[week].Number_Hours) : 0) * (uData[week].Number_Units ? pNum(uData[week].Number_Units) : 0) * (uData[week].Rate ? pNum(uData[week].Rate) : 0) : 0)
                totalEstWeekHours = totalEstWeekHours + (uData[week] ? (uData[week].Number_Hours ? pNum(uData[week].Number_Hours) : 0) * (uData[week].Number_Units ? pNum(uData[week].Number_Units) : 0) : 0)
            } else if (plannedFinish.isAfter(moment(week))) {
                cummalitiveHours = cummalitiveHours + (weeksHours[week] ? weeksHours[week] : 0)
                cummalitiveHoursAct = cummalitiveHoursAct + (weeksHours[week] ? weeksHours[week] : 0)
            }
            totalActualWeekCost = totalActualWeekCost + (weeksAmount[week] ? weeksAmount[week] : 0)
            totalActualWeekHours = totalActualWeekHours + (weeksHours[week] ? weeksHours[week] : 0)
            totalForecastedHours = totalForecastedHours + (uData[week] ? (uData[week].Number_Hours ? pNum(uData[week].Number_Hours) : 0) : 0)

            const future = !moment(week).isBefore(moment())
            estimatedWeeks.push({
                id: index + 1,
                jobWeek: index + 1,
                week: week,
                highlight: !moment(week).isBefore(moment()),
                actualWeeklyHours: uData[week] ? (uData[week].Number_Hours ? pNum(uData[week].Number_Hours) : 0) * (uData[week].Number_Units ? pNum(uData[week].Number_Units) : 0) : 0,
                cummalitiveHours: cummalitiveHours.toFixed(),
                actualWeeklyCost: uData[week] ? (uData[week].Number_Hours ? pNum(uData[week].Number_Hours) : 0) * (uData[week].Number_Units ? pNum(uData[week].Number_Units) : 0) * (uData[week].burnPerHour ? pNum(uData[week].burnPerHour) : 0) : 0,
                burnPerHour: uData[week]?.Rate,
                numOfWorkers: uData[week]?.Number_Units,
                hoursPerWeek: uData[week]?.Number_Hours,
                notes: uData[week]?.Notes,
                countEst: 0
            })

            !future ? historicalWeeks.push({
                id: index + 1,
                jobWeek: index + 1,
                week: week,
                highlight: !moment(week).isBefore(moment()),
                actualWeeklyHours: weeksHours[week] ? weeksHours[week] : 0,
                cummalitiveHours: cummalitiveHours,
                actualWeeklyCost: weeksAmount[week] ? weeksAmount[week] : 0,
                burnPerHour: 0,
                countEst: weeksData[week] ? weeksData[week].count : 0
            }) : null

        })
        setTotalActualCost(fNum(totalActualWeekCost, 1))
        setTotalActualHours(fNum(totalActualWeekHours, 1))
        setTotalHourPerWeek(fNum(totalHourPerWeek, 1))
        setTotalBurnPerHour(cummalitiveCostEst && cummalativeHoursEst && pNum(cummalativeHoursEst) > 0 ? fNum(pNum(cummalitiveCostEst) / pNum(cummalativeHoursEst), 1) : 0)
        setTotalEstHours(fNum(cummalativeHoursEst, 1))
        setTotalEstCost(fNum(cummalitiveCostEst, 1))
        setTotalLaborEst(fNum(cummalitiveLaborEst, 1))
        setTotalCummalitiveHours(fNum(cummalitiveHours, 1))
        setTotalLaborHoursEst(fNum(totalEstWeekHours, 1))
        // if (cummalitiveLaborEst) {
        //     saveTotal('51100', cummalitiveLaborEst)
        // }
        // saveTotal('', cummalitiveLaborEst && pNum(cummalitiveLaborEst) > 0 ? fNum(100 * pNum(totalActualWeekCost) / pNum(cummalitiveLaborEst),1) : '', 'laborPercentage')

        setTotalForecastedHours(fNum(totalForecastedHours, 1))
        setEstimatedWeeks(estimatedWeeks)
        setHistoricalWeeks(historicalWeeks)
        setForecastLaborCost(fNum(cummalitiveCostEst,1))
        setForecastLaborHours(fNum(cummalativeHoursEst,1))
        setTotalHours(fNum(pNum(totalHours) + pNum(cummalativeHoursEst),1))
        setTotalCost(fNum(pNum(totalCost) + pNum(cummalitiveCostEst),1))
        setOverUnder(fNum(pNum(currentBudget) - (pNum(totalCost) + pNum(cummalitiveCostEst)),1))
        setOverUnderHours(fNum(pNum(currentBudgetHours) - (pNum(totalHours) + pNum(cummalativeHoursEst)),1))
        setPercentComplete(currentBudget && pNum(currentBudget) > 0 && totalCost ? fNum(totalCost / pNum(currentBudget) * 100,1) + '%' : '')
        setPercentCompleteHours(currentBudgetHours && pNum(currentBudgetHours) > 0 && totalHours ? fNum(totalHours / pNum(currentBudgetHours) * 100,1) + '%': '')

        // --- Manpower Planning props (phase-shaped, one "ALL" crew) ---
        // projectDates maps each day to its week key (same array shape the
        // phased tool passes); projectWeeksData mirrors the phased weekly
        // roll-up keys ManpowerPlanning reads.
        const mpProjectData = {}
        const mpUData = {}
        Object.keys(uniqueWeeks).forEach((week) => {
            const est = uData[week]
            if (est) mpUData['ALL=' + week] = est
            const estHrs = est ? (pNum(est.Number_Hours) || 0) * (pNum(est.Number_Units) || 0) : 0
            const isEtcWeek = plannedFinish.isAfter(moment(week)) && moment(week).isAfter(moment(versionInfo.Version_Start_DateTime).add(-7, 'days'))
            mpProjectData[week] = {
                actualHours: weeksHours[week] ? fNum(weeksHours[week], 1) : '',
                actualCrewSize: weeksData[week]?.count ? fNum(weeksData[week].count) : '',
                etcCrewSize: est?.Number_Units ? fNum(pNum(est.Number_Units)) : '',
                etcHours: isEtcWeek && estHrs ? fNum(estHrs, 1) : '',
                plannedHours: estHrs ? fNum(estHrs, 1) : '',
            }
        })
        setMpUserData(mpUData)
        setProjectWeeksData(mpProjectData)
        setProjectDates(dateSections)
        setProjectWeeks(Object.keys(uniqueWeeks))
    }

    const HistoricalRow = ({ row }) => {
        const isHours = row.actualWeeklyCost || row.actualWeeklyHours ? true : false
        const burnPerHour = pNum(row.actualWeeklyHours) > 0 ? pNum(row.actualWeeklyCost) / pNum(row.actualWeeklyHours) : ''
        const isCurrentWeek = moment(row.week).add(1, 'week').isSame(moment(versionInfo?.Version_Start_DateTime), 'week')
        const heetCost = heetWeeklyData[row.week] || 0
        const hasHeetData = heetCost > 0

        return (
            <View style={[s.container, { borderBottomWidth: isCurrentWeek ? 2 : 1, borderColor: isCurrentWeek ? '#0f172a' : '#e0e0e0' }]}>
                <Text style={s.spanHT}>
                    {row.jobWeek}
                </Text>
                <Text style={[s.spanWeek, { backgroundColor: guardAdmin && hasHeetData ? '#e3f2fd' : 'white' }]}>
                    {row.week}
                </Text>
                <Text style={[s.spanT, { backgroundColor: isHours ? 'white' : '#d3d3d3' }]}>
                    {isHours ? fNum(row.actualWeeklyHours) : ''}
                </Text>
                <Text style={[s.spanT, { backgroundColor: isHours ? 'white' : '#d3d3d3' }]}>
                    {isHours ? fNum(row.cummalitiveHours) : ''}
                </Text>
                <Text style={[s.spanT, { backgroundColor: isHours ? 'white' : '#d3d3d3' }]}>
                    {isHours ? fNum(row.actualWeeklyCost) : ''}
                </Text>
                <Text style={[s.spanT, { backgroundColor: isHours ? 'white' : '#d3d3d3' }]}>
                    {isHours && burnPerHour ? (burnPerHour).toFixed(2) : ''}
                </Text>
                <Text style={[s.spanT, { backgroundColor: isHours ? 'white' : '#d3d3d3' }]}>
                    {isHours ? fNum(row.countEst) : ''}
                </Text>
                {guardAdmin && hasHeetData && (
                    <Text style={[s.spanT, { backgroundColor: '#bbdefb', marginLeft: 5 }]}>
                        HEET: {fNum(heetCost)}
                    </Text>
                )}
            </View>
        )
    }


    const EstimatedRow = ({ row, truckPay, rigRent }) => {
        const [burnPerHour, setBurnPerHour] = useState(row.burnPerHour)
        const [numOfWorkers, setNumOfWorkers] = useState(row.numOfWorkers)
        const [hoursPerWeek, setHoursPerWeek] = useState(row.hoursPerWeek)
        const [weeklyCost, setWeeklyCost] = useState(row.actualWeeklyCost)
        const [weeklyHours, setWeeklyHours] = useState(row.actualWeeklyHours)
        const [notes, setNotes] = useState(row.notes)
        const isInFuture = moment(row.week).add(1, 'week').isAfter(moment(versionInfo?.Version_Start_DateTime))
        const isCurrentWeek = moment(row.week).add(1, 'week').isSame(moment(versionInfo?.Version_Start_DateTime), 'week')
        const [localFocusedId, setLocalFocusedId] = useState(focusedId.current)
        const inputsRef = useRef([])
        const uniqueId = (truckPay ? 'truckPay' : rigRent ? 'rigRent' : 'labor') + row.week
        const [textTimeout, setTextTimeout] = useState(null)
        const [noteHeight, setNoteHeight] = useState(0)


        useEffect(() => {
            if (focusedId.current == (uniqueId + '-burnPerHour')) {
                inputsRef.current[uniqueId + '-burnPerHour'].focus()
            } else if (focusedId.current == (uniqueId + '-numOfWorkers')) {
                inputsRef.current[uniqueId + '-numOfWorkers'].focus()
            } else if (focusedId.current == (uniqueId + '-hoursPerWeek')) {
                inputsRef.current[uniqueId + '-hoursPerWeek'].focus()
            } else if (focusedId.current == (uniqueId + '-notes')) {
                inputsRef.current[uniqueId + '-notes'].focus()
            }
        }, [localFocusedId])

        const updateLocalChanges = async (field, burnPerHour, numOfWorkers, hoursPerWeek, notes) => {
            console.log('updating local changes', field, burnPerHour, numOfWorkers, hoursPerWeek, notes)
            if (selectedJob) {
                console.log('updating local changes', burnPerHour, numOfWorkers, hoursPerWeek, notes, row)
                let data = {
                    active: 1,
                    userId: userId || 'seth.bailey@strikeusa.com',
                    userName: userName || 'Seth Bailey',
                    fieldName: 'row',
                    tab: "Burn Tool Labor",
                    rowId: row.week + '*labor',
                    version: selectedVersion + '',
                    value: pNum(numOfWorkers) * pNum(hoursPerWeek) * pNum(burnPerHour),
                    valueAmount: pNum(numOfWorkers) * pNum(hoursPerWeek) * pNum(burnPerHour),
                    notes: notes,
                    projectStart: selectedJobData?.Planned_Start_Date,
                    projectFinish: completionDateForecast ? completionDateForecast : selectedJobData?.Planned_Complete_Date,
                    phaseStart: selectedJobData?.Phase_Start_Date,
                    phaseFinish: completionDateForecast ? completionDateForecast : selectedJobData?.Phase_Complete_Date,
                    rate: burnPerHour,
                    numberHours: hoursPerWeek,
                    numberUnits: numOfWorkers,
                    hours: numOfWorkers * hoursPerWeek,
                    active: 1,
                    id: selectedJob,
                    costType: '51100',
                    lockedVersion: lockedVersion
                }
                console.log('saving data', data)
                trackApi('updateUserDataArray', 'save', () => updateUserDataArray(data)).catch(() => {})

                const stateUpdate = {
                    Forecast_Field_Name: field,
                    Forecast_Value: pNum(numOfWorkers) * pNum(hoursPerWeek) * pNum(burnPerHour),
                    Value_Amount: pNum(numOfWorkers) * pNum(hoursPerWeek) * pNum(burnPerHour),
                    Notes: notes,
                    Project_Start: selectedJobData?.Planned_Start_Date,
                    Project_Finish: completionDateForecast ? completionDateForecast : selectedJobData?.Planned_Complete_Date,
                    Phase_Start: selectedJobData?.Phase_Start_Date,
                    Phase_Finish: completionDateForecast ? completionDateForecast : selectedJobData?.Phase_Complete_Date,
                    Rate: burnPerHour,
                    Number_Hours: hoursPerWeek,
                    Number_Units: numOfWorkers,
                    Active: 1,
                    Forecast_Row_ID: row.week + '*labor',
                    Forecast_Tab: "Burn Tool Labor",
                    BU_ID: selectedJob,
                    Cost_Type: '51100',
                    key: row.week + '*labor'
                }

                let lChanges = {}
                localChanges.current.forEach((d) => {
                    lChanges[d.Forecast_Row_ID] = d
                })

                lChanges[row.week + '*labor'] = stateUpdate
                localChanges.current = Object.values(lChanges)
            }
        }

        const updateState = () => {
            let latestChanges = {};
            localChanges.current.forEach((d) => {
                latestChanges[d.Forecast_Row_ID] = d;
            });
            let notUpdated = Object.values(latestChanges);
            let uData = jobUserData ? jobUserData.filter(
                d => !latestChanges[d.Forecast_Row_ID]
            ) : [];
            setJobUserData([...uData, ...notUpdated])
        }

        useEffect(() => {
            const hPW = hoursPerWeek ? pNum(hoursPerWeek) : 0
            const nOW = numOfWorkers ? pNum(numOfWorkers) : 0
            const bPH = burnPerHour ? pNum(burnPerHour) : 0
            setWeeklyHours(hPW * nOW)
            setWeeklyCost(hPW * nOW * bPH)
        }, [hoursPerWeek, numOfWorkers, burnPerHour])

        return (
            <View style={[s.container, { borderBottomWidth: isCurrentWeek ? 2 : 1, borderColor: isCurrentWeek ? '#0f172a' : '#e0e0e0' }]}>
                <Text style={s.spanHT}>
                    {row.jobWeek}
                </Text>
                <Text style={s.spanWeek}>
                    {row.week}
                </Text>
                <Text style={s.spanT}>
                    {isInFuture ? fNum(weeklyHours, 1) : numOfWorkers ? fNum(numOfWorkers * hoursPerWeek, 1) : ''}
                </Text>
                <Text style={s.spanT}>
                    {isInFuture ? fNum(row.cummalitiveHours, 1) : ''}
                </Text>
                <Text style={s.spanT}>
                    {isInFuture ? fNum(weeklyCost, 1) : numOfWorkers ? fNum(numOfWorkers * hoursPerWeek * burnPerHour, 1) : ''}
                </Text>
                {isInFuture ? <TextInput style={s.tInput}
                    value={burnPerHour}
                    ref={e => { inputsRef.current[uniqueId + '-burnPerHour'] = e }}
                    onFocus={() => { focusedId.current = uniqueId + '-burnPerHour' }}  // Track the input when focused
                    onChangeText={t => {
                        setBurnPerHour(t)
                        clearTimeout(textTimeout)
                        console.log('seth')
                        updateLocalChanges('burnPerHour', t, numOfWorkers, hoursPerWeek, notes)
                        setLocalFocusedId(uniqueId + '-burnPerHour')
                        if (t.length > 0) {
                            setTextTimeout(setTimeout(() => {
                                updateState()
                            }, 1000))
                        }
                    }}
                >
                </TextInput> : <Text style={s.spanT}>{burnPerHour}</Text>}
                {isInFuture ? <TextInput style={s.tInput}
                    value={numOfWorkers}
                    ref={e => { inputsRef.current[uniqueId + '-numOfWorkers'] = e }}
                    onFocus={() => { focusedId.current = uniqueId + '-numOfWorkers' }}  // Track the input when focused
                    onChangeText={t => {
                        setNumOfWorkers(t)
                        clearTimeout(textTimeout)
                        updateLocalChanges('numOfWorkers', burnPerHour, t, hoursPerWeek, notes)
                        setLocalFocusedId(uniqueId + '-numOfWorkers')
                        if (t.length > 0) {
                            setTextTimeout(setTimeout(() => {
                                updateState()
                            }, 1000))
                        }
                    }}>
                </TextInput> : <Text style={s.spanT}>{numOfWorkers}</Text>}
                {isInFuture ? <TextInput style={s.tInput}
                    value={hoursPerWeek}
                    ref={e => { inputsRef.current[uniqueId + '-hoursPerWeek'] = e }}
                    onFocus={() => { focusedId.current = uniqueId + '-hoursPerWeek' }}  // Track the input when focused
                    onChangeText={t => {
                        setHoursPerWeek(t)
                        clearTimeout(textTimeout)
                        updateLocalChanges('hoursPerWeek', burnPerHour, numOfWorkers, t, notes)
                        setLocalFocusedId(uniqueId + '-hoursPerWeek')
                        if (t.length > 0) {
                            setTextTimeout(setTimeout(() => {
                                updateState()
                            }, 1000))
                        }
                    }}>
                </TextInput> : <Text style={s.spanT}>{hoursPerWeek}</Text>}
                <View style={{ flexDirection: 'row' }}>
                    <Text style={s.spanT}>
                        {totalHours ? fNum(pNum(row.cummalitiveHours) * 100 / pNum(totalHours)) + '%' : ''}
                    </Text>
                    <TextInput style={[s.tInputL]}
                        ref={e => { inputsRef.current[uniqueId + '-notes'] = e }}
                        onFocus={() => { focusedId.current = uniqueId + '-notes' }}  // Track the input when focused
                        value={notes}
                        onChangeText={t => {
                            setNotes(t)
                            clearTimeout(textTimeout)
                            updateLocalChanges('notes', burnPerHour, numOfWorkers, hoursPerWeek, t)
                            setLocalFocusedId(uniqueId + '-notes')
                            if (t.length > 0) {
                                setTextTimeout(setTimeout(() => {
                                    updateState()
                                }, 1000))
                            }
                        }}>
                    </TextInput>
                </View>
            </View>
        )
    }

    const exportHEETToExcel = async () => {
        try {
            if (!jobHEETData || !Array.isArray(jobHEETData) || jobHEETData.length === 0) {
                alert('No HEET data available to export.');
                return;
            }
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('HEET Data');

            worksheet.columns = [
                { header: 'GL Date', key: 'GL_Date', width: 15 },
                { header: 'Phase Code', key: 'Phase_Code', width: 15 },
                { header: 'Cost Type Code', key: 'Cost_Type_Code', width: 18 },
                { header: 'GL Amount', key: 'GL_Amount', width: 15 },
                { header: 'Record Type', key: 'Record_Type', width: 15 },
                { header: 'Craft Description', key: 'Job_Type_Craft_Code_Description', width: 30 },
                { header: 'Units', key: 'Units', width: 12 },
                { header: 'BU ID', key: 'BU_ID', width: 12 },
            ];

            // Style header row
            worksheet.getRow(1).font = { bold: true };
            worksheet.getRow(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE2E8F0' } };

            jobHEETData.forEach((row) => {
                worksheet.addRow({
                    GL_Date: row.GL_Date ? moment(row.GL_Date).format('MM/DD/YYYY') : '',
                    Phase_Code: row.Phase_Code || '',
                    Cost_Type_Code: row.Cost_Type_Code || '',
                    GL_Amount: row.GL_Amount != null ? pNum(row.GL_Amount) : '',
                    Record_Type: row.Record_Type || '',
                    Job_Type_Craft_Code_Description: row.Job_Type_Craft_Code_Description || '',
                    Units: row.Units != null ? pNum(row.Units) : '',
                    BU_ID: row.BU_ID || '',
                });
            });

            // Format GL Amount column as currency
            worksheet.getColumn('GL_Amount').numFmt = '$#,##0.00';

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = `HEET_Data_Job${selectedJob}_${moment().format('YYYYMMDD_HHmmss')}.xlsx`;
            saveAs(blob, filename);
        } catch (error) {
            console.error('Error exporting HEET data:', error);
            alert('Error exporting HEET data to Excel. Please try again.');
        }
    };

    const guardAdmin = process.env.NODE_ENV !== 'production' || userId === '154045' || userId === '147219' || userEmailCheck === 'christopher.ellis@strikeusa.com';

    const forecastWeek = moment(versionInfo?.Version_Start_DateTime).add(-7, 'days')

    // Default Manpower Planning window: 5 weeks back / 10 weeks forward of the
    // forecast week (same window the phased burn tool starts from); jobs that
    // already ended anchor to the last 15 project weeks instead.
    const visibleWeeks = React.useMemo(() => {
        if (!projectWeeks.length || !versionInfo?.Version_Start_DateTime) return projectWeeks;
        const todayWeek = moment(versionInfo.Version_Start_DateTime).add(-7, 'days').startOf('isoWeek');
        const lastProjectWeek = moment(projectWeeks[projectWeeks.length - 1]);
        if (lastProjectWeek.isBefore(todayWeek, 'week')) {
            return projectWeeks.slice(Math.max(0, projectWeeks.length - 15));
        }
        const todayIdx = projectWeeks.findIndex(w => moment(w).isSameOrAfter(todayWeek, 'week'));
        if (todayIdx === -1) return projectWeeks;
        const startIdx = Math.max(0, todayIdx - 5);
        const endIdx = Math.min(projectWeeks.length - 1, todayIdx + 10);
        return projectWeeks.slice(startIdx, endIdx + 1);
    }, [projectWeeks, versionInfo]);

    return (
        <View style={{ margin: 30, marginBottom: 100, marginRight: 100 }}>
            {/* Subtab switcher: Burn Tool ↔ Manpower Planning */}
            {canSeeWipTabs && (
            <View style={{ flexDirection: 'row', gap: 4, marginBottom: 14, borderBottom: `1px solid ${colors.borderLight}`, paddingBottom: 0, alignItems: 'center' }}>
                {[{ key: 'burn', label: 'Burn Tool' }, { key: 'manpower', label: 'Manpower Planning' }].filter((t) => !isPC || t.key === 'manpower').map((t) => (
                    <Pressable
                        key={t.key}
                        onPress={() => setMpSubTab(t.key)}
                        style={{
                            paddingTop: 8,
                            paddingBottom: 8,
                            paddingLeft: 16,
                            paddingRight: 16,
                            borderBottom: `2px solid ${activeMpTab === t.key ? colors.accent : 'transparent'}`,
                            cursor: 'pointer',
                        }}
                    >
                        <Text style={{ fontSize: 14, fontWeight: activeMpTab === t.key ? '700' : '500', color: activeMpTab === t.key ? colors.accent : colors.textSecondary }}>{t.label}</Text>
                    </Pressable>
                ))}
                {activeMpTab === 'manpower' && (
                    <Pressable onPress={() => setMpAllWeeks(v => !v)} style={{ marginLeft: 'auto', marginBottom: 6, padding: 6, paddingLeft: 12, paddingRight: 12, borderRadius: 6, border: `1px solid ${colors.borderLight}`, backgroundColor: mpAllWeeks ? '#dbeafe' : '#f8fafc', cursor: 'pointer' }}>
                        <Text style={{ fontSize: 12, fontWeight: '600', color: mpAllWeeks ? colors.accent : colors.textSecondary }}>{mpAllWeeks ? 'Current Window' : 'All Weeks'}</Text>
                    </Pressable>
                )}
            </View>
            )}
            {activeMpTab === 'manpower' && (
                <ManpowerPlanning
                    expandedWeeks={mpAllWeeks}
                    projectWeeks={projectWeeks}
                    visibleWeeks={visibleWeeks}
                    versionInfo={versionInfo}
                    currentBudgetHours={currentBudgetHours}
                    actualHours={actualLaborHours}
                    etcHours={forecastLaborHours}
                    totalHours={totalHours}
                    overUnderHours={-(pNum(overUnderHours) || 0)}
                    dayZeroHourTotal={totalDayZeroHours}
                    coHours={totalCOHours}
                    phaseDescriptions={MP_ALL_LABOR_PHASES}
                    userData={mpUserData}
                    estPhaseHourTotals={{ ALL: pNum(forecastLaborHours) || 0 }}
                    actualPhaseHourTotals={{ ALL: pNum(actualLaborHours) || 0 }}
                    jobCostDetail={jobCostDetail}
                    projectDates={projectDates}
                    projectWeeksData={projectWeeksData}
                    forecastWeek={forecastWeek}
                />
            )}
            {activeMpTab === 'burn' && <>
            {guardAdmin && <View style={{ marginBottom: 10, alignItems: 'flex-end' }}>
                <Pressable
                    onPress={exportHEETToExcel}
                    style={{
                        alignItems: 'center',
                        backgroundColor: '#f8fafc',
                        padding: 10,
                        paddingHorizontal: 14,
                        borderRadius: 6,
                        flexDirection: 'row',
                        border: '1px solid #cbd5e1',
                        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                        cursor: (!jobHEETData || jobHEETData.length === 0) ? 'not-allowed' : 'pointer',
                        opacity: (!jobHEETData || jobHEETData.length === 0) ? 0.5 : 1,
                    }}
                >
                    <Text style={{ marginRight: 8, color: '#334155', fontWeight: '500', fontSize: 13 }}>Export HEET</Text>
                    <Text style={{ color: '#334155', fontSize: 16 }}>↓</Text>
                </Pressable>
            </View>}
            <View style={{ flexDirection: 'row', marginTop: 20 }}>
                <View style={{ alignItems: 'flex-end' }}>
                    <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                        <View style={s.container}>
                            <View style={s.span2H}>
                            </View>
                                <Text style={s.spanH}>
                                    Budget
                                </Text>
                                <Text style={s.spanH}>
                                    CO Log
                                </Text>
                                <Text style={s.spanH}>
                                    Current Budget
                                </Text>
                                <Text style={s.spanH}>
                                    Actuals
                                </Text>
                                <Text style={s.spanH}>
                                    Projected
                                </Text>
                                <Text style={s.spanH}>
                                    Total
                                </Text>
                                <Text style={s.spanH}>
                                    (Over)/Under
                                </Text>
                                <Text style={s.spanH}>
                                    % Comp
                                </Text>
                            </View>
                            <View style={s.container}>
                                <Text style={s.span2H}>
                                    Total Labor Hours
                                </Text>
                                <Text style={s.spanT}>
                                    {totalDayZeroHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {totalCOHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {currentBudgetHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {actualLaborHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {forecastLaborHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {totalHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {overUnderHours}
                                </Text>
                                <Text style={s.spanT}>
                                    {percentCompleteHours}
                                </Text>
                            </View>
                            <View style={s.container}>
                                <Text style={s.span2H}>
                                    Total Labor Cost
                                </Text>
                                <Text style={s.spanT}>
                                    {totalDayZero}
                                </Text>
                                <Text style={s.spanT}>
                                    {totalCOCost}
                                </Text>
                                <Text style={s.spanT}>
                                    {currentBudget}
                                </Text>
                                <Text style={s.spanT}>
                                    {actualLaborCost}
                                </Text>
                                <Text style={s.spanT}>
                                    {forecastLaborCost}
                                </Text>
                                <Text style={s.spanT}>
                                    {totalCost}
                                </Text>
                                <Text style={s.spanT}>
                                    {overUnder}
                                </Text>
                                <Text style={s.spanT}>
                                    {percentComplete}
                                </Text>
                            </View>
                            <View style={s.container}>
                                <Text style={s.span2H}>
                                    Total Burn Rate
                                </Text>
                                <Text style={s.spanT}>
                                    {totalDayZeroHours && pNum(totalDayZeroHours) > 0 ? fNum(pNum(totalDayZero) / pNum(totalDayZeroHours)) : ''}
                                </Text>
                                <Text style={s.spanT}>
                                    {totalCOHours && pNum(totalCOHours) > 0 ? fNum(pNum(totalCOCost) / pNum(totalCOHours)) : ''}
                                </Text>
                                <Text style={s.spanT}>
                                    {currentBudgetHours && pNum(currentBudgetHours) > 0 ? fNum(pNum(currentBudget) / pNum(currentBudgetHours)) : ''}
                                </Text>
                                <Text style={s.spanT}>
                                    {actualLaborHours && pNum(actualLaborHours) > 0 ? fNum(pNum(actualLaborCost) / pNum(actualLaborHours)) : ''}
                                </Text>
                                <Text style={s.spanT}>
                                    {forecastLaborHours && pNum(forecastLaborHours) > 0 ? fNum(pNum(forecastLaborCost) / pNum(forecastLaborHours)) : ''}
                                </Text>
                                <Text style={s.spanT}>
                                    {totalHours && pNum(totalHours) > 0 ? fNum(pNum(totalCost) / pNum(totalHours)) : ''}
                                </Text>
                                <Text style={s.spanT}>
                                </Text>
                                <Text style={s.spanT}>
                                </Text>
                            </View>

                        </View>
                    </View>
                </View>
                <View style={{ flexDirection: 'row', borderRadius: 5 }}>
                    <View style={{ alignItems: 'flex-end' }}>
                        <Text style={s.sectionTitle}>Historical Weeks on Job #{selectedJob}</Text>
                        <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.08, shadowRadius: 4, elevation: 2 }}>
                            <View style={[s.container, { position: 'sticky', backgroundColor: '#f1f5f9', top: 0, zIndex: 10 }]}>
                                <Text style={s.spanHH}>
                                    Job Week
                                </Text>
                                <Text style={s.spanWeekH}>
                                    Week (starting Monday)
                                </Text>
                                <Text style={s.spanH}>
                                    Act. Weekly Hours
                                </Text>
                                <Text style={s.spanH}>
                                    Cumulative Hours
                                </Text>
                                <Text style={s.spanH}>
                                    Act. Weekly Cost
                                </Text>
                                <Text style={s.spanH}>
                                    Burn per hour
                                </Text>
                                <Text style={s.spanH}>
                                    Man Count Est.
                                </Text>
                            </View>
                            {historicalWeeks.map((row, index) => (
                                <HistoricalRow key={index} row={row} />))
                            }
                            <View style={s.container}>
                                <Text style={s.spanHTotals}>
                                </Text>
                                <Text style={s.spanWeekTotals}>
                                    Totals
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalActualHours}
                                </Text>
                                <Text style={s.spanTotals}>
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalActualCost}
                                </Text>
                                <Text style={s.spanTotals}>
                                    {fNum(pNum(totalActualCost) / pNum(totalActualHours))}
                                </Text>
                                <Text style={s.spanTotals}>
                                </Text>
                            </View>
                        </View>
                    </View>
                    <View style={{ alignItems: 'flex-end' }}>
                        <Text style={s.sectionTitle}>Estimated Weeks on Job #{selectedJob}</Text>
                        <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, marginLeft: 10, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.08, shadowRadius: 4, elevation: 2 }}>
                            <View style={[s.container, { position: 'sticky', backgroundColor: '#f1f5f9', top: 0, zIndex: 10 }]}>
                                <Text style={s.spanHH}>
                                    Job Week
                                </Text>
                                <Text style={s.spanWeekH}>
                                    Week (starting Monday)
                                </Text>
                                <Text style={s.spanH}>
                                    Weekly Hours
                                </Text>
                                <Text style={s.spanH}>
                                    Cumulative Hours
                                </Text>
                                <Text style={s.spanH}>
                                    Weekly Cost
                                </Text>
                                <Text style={s.spanH}>
                                    Burn per hour
                                </Text>
                                <Text style={s.spanH}>
                                    # of Workers
                                </Text>
                                <Text style={s.spanH}>
                                    # of Hours per week
                                </Text>
                                <Text style={s.spanH}>
                                    % Complete
                                </Text>
                                <Text style={s.span3H}>
                                    Weekly Events / Schedule / Milestones / Explanation of Manpower
                                </Text>
                            </View>
                            {estimatedWeeks.map((row, index) => (
                                <EstimatedRow key={index} row={row} />))
                            }
                            <View style={s.container}>
                                <Text style={s.spanHTotals}>
                                </Text>
                                <Text style={s.spanWeekTotals}>
                                    Projected Totals
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalLaborHoursEst}
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalCummalitiveHours}
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalLaborEst}
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalBurnPerHour}
                                </Text>
                                <Text style={s.spanTotals}>
                                </Text>
                                <Text style={s.spanTotals}>
                                    {totalForecastedHours}
                                </Text>
                                <Text style={s.spanTotals}>
                                </Text>
                                <Text style={s.span3Totals}>
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
            </>}
            <AuditHistoryPanel tabKey="labor" />
            </View>
    );
};

export default BurnTool;


